import React, { useEffect, useState, useContext, useCallback } from "react";
import { useIntl } from "react-intl";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { NotificationsContext } from "ui-components/Notifications";
import { PriceListSearch, PriceListSearchHistory } from "@feature/price-list";
import AuthenticationService from "../services/AuthenticationService";

const PriceList = () => {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const userData = AuthenticationService.getUserData();
  const countryApiRequest = useCountryAxiosInstance();

  // State
  const [startSearch, setStartSearch] = useState(false);
  const [canSearch, setCanSearch] = useState(false);
  const [priceListData, setPriceListData] = useState({});
  const [priceListHistory, setPriceListHistory] = useState([]);

  const fetchHistory = useCallback(async () => {
    try {
      let params = {
        cache_key: {
          userId: userData.id,
        },
        schema_version: 1,
        result_type: "kcolor_price_list",
      };
      const res = await countryApiRequest.post(
        "/remote_calculation/get_results",
        params
      );
      res.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setPriceListHistory(res);
    } catch (e) {
      console.error(e);
      push(intl.formatMessage({ id: "server_error" }));
    }
  }, [countryApiRequest, push, intl]);

  useEffect(() => {
    if (!startSearch){ 
      fetchHistory();
      setPriceListData({});
    }
  }, [startSearch]);

  return (
    <>
      <div className="min-h-full pt-4 pb-12 flex flex-col">
        <PriceListSearch
          intl={intl}
          startSearch={startSearch}
          setStartSearch={setStartSearch}
          priceListData={priceListData}
          setPriceListData={setPriceListData}
          canSearch={canSearch}
          setCanSearch={setCanSearch}
          priceListHistory={priceListHistory}
          setPriceListHistory={setPriceListHistory}
          push={push}
        />
      </div>

      {/* Mostra la cronologia delle ricerche se non è in corso una ricerca */}
      {!startSearch && priceListHistory && (
        <PriceListSearchHistory
          priceListHistory={priceListHistory}
          setPriceListData={setPriceListData}
          setStartSearch={setStartSearch}
          fetchHistory={fetchHistory}
        />
      )}
    </>
  );
};

export default PriceList;
